import { createContext, useContext } from 'react'

interface TrackingInfo {
  screenName: string
}

export const TrackingInfoContext = createContext<TrackingInfo>({
  screenName: ''
})

export const useTrackingInfoProvider = (trackingInfo: TrackingInfo): TrackingInfo => {
  return {
    ...trackingInfo
  }
}

const useTrackingInfo = () => useContext(TrackingInfoContext)

export default useTrackingInfo
